import { render, staticRenderFns } from "./TopNavigation.vue?vue&type=template&id=31fca8e8&scoped=true&"
import script from "./TopNavigation.vue?vue&type=script&lang=js&"
export * from "./TopNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TopNavigation.vue?vue&type=style&index=0&id=31fca8e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fca8e8",
  null
  
)

export default component.exports